/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'history': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm3.5 17.8l-4.2-4.2v-7h1.4V13l3.8 3.8-1 1z" _fill="#757e8d"/>'
  }
})
